import { useEffect } from "react";

/**
 * Pauses the global Lenis smooth-scroll instance while a modal/dialog is
 * open, so wheel/touch input inside the dialog's own scrollable area works
 * natively instead of being hijacked by Lenis and leaking to the page behind it.
 */
export const useLenisPause = (isOpen) => {
  useEffect(() => {
    const lenis = window.__lenis;
    if (!lenis) return;
    if (isOpen) {
      lenis.stop();
    } else {
      lenis.start();
    }
    return () => {
      lenis.start();
    };
  }, [isOpen]);
};
